import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { hide_global_dialog } from '@/actions';
import CustomConfirmDialog from '@/components/CustomConfirmDialog';

const GlobalDialog = () => {
  const { globalDialogState, message = {} } = useSelector(state => state.notificationInfo);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const text = _.get(message, ['text'], '');

  const handleFunc = () => {
    if (message.type === 'EVALUATION_REPORT_TO_STAFF') {
      navigate('/client/health-report');
    }
  }

  return (
    <CustomConfirmDialog
      visible={globalDialogState}
      content={text}
      onCancel={() => {
        dispatch(hide_global_dialog())
      }}
      onConfirm={() => {
        dispatch(hide_global_dialog());
        handleFunc()
      }}
    />
  )
};

export default GlobalDialog
